/* import __COLOCATED_TEMPLATE__ from './offering-calendar.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { restartableTask } from 'ember-concurrency';
import { map } from 'rsvp';
import { deprecate } from '@ember/debug';
import { DateTime } from 'luxon';
let OfferingCalendar = (_class = class OfferingCalendar extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "showLearnerGroupEvents", _descriptor, this);
    _initializerDefineProperty(this, "showSessionEvents", _descriptor2, this);
    _initializerDefineProperty(this, "learnerGroupEvents", _descriptor3, this);
    _initializerDefineProperty(this, "sessionEvents", _descriptor4, this);
    _initializerDefineProperty(this, "currentEvent", _descriptor5, this);
    _defineProperty(this, "load", _buildTask(() => ({
      context: this,
      generator: function* (element, [startDate, endDate, learnerGroups, session]) {
        if (!learnerGroups) {
          this.learnerGroupEvents = [];
        } else {
          const data = yield map(learnerGroups, async learnerGroup => {
            const offerings = await learnerGroup.offerings;
            return await map(offerings, async offering => {
              const session = await offering.session;
              const course = await session.course;
              return {
                startDate: DateTime.fromJSDate(offering.startDate).toISO(),
                endDate: DateTime.fromJSDate(offering.endDate).toISO(),
                courseTitle: course.title,
                name: session.title,
                offering: offering.id,
                location: offering.location,
                color: '#84c444',
                postrequisites: [],
                prerequisites: []
              };
            });
          });
          this.learnerGroupEvents = data.reduce((flattened, obj) => {
            return [...flattened, ...obj];
          }, []);
        }
        if (!session) {
          this.sessionEvents = [];
          this.currentEvent = null;
        } else {
          const offerings = yield session.offerings;
          const sessionType = yield session.sessionType;
          const course = yield session.course;
          this.sessionEvents = yield map(offerings, async offering => {
            return {
              startDate: DateTime.fromJSDate(offering.startDate).toISO(),
              endDate: DateTime.fromJSDate(offering.endDate).toISO(),
              courseTitle: course.title,
              name: session.title,
              offering: offering.id,
              location: offering.location,
              color: '#f6f6f6',
              postrequisites: [],
              prerequisites: []
            };
          });
          this.currentEvent = {
            startDate: DateTime.fromJSDate(startDate).toISO(),
            endDate: DateTime.fromJSDate(endDate).toISO(),
            courseTitle: course.title,
            name: session.title,
            isPublished: session.isPublished,
            offering: 1,
            location: '',
            color: sessionType.calendarColor,
            postrequisites: [],
            prerequisites: []
          };
        }
      }
    }), null, "load", "restartable"));
  }
  get startDate() {
    if (typeof this.args.startDate === 'string') {
      deprecate(`String passed to OfferingCalendar @startDate instead of Date`, false, {
        id: 'common.dates-no-strings',
        for: 'ilios-common',
        until: '72',
        since: '71'
      });
      return DateTime.fromISO(this.args.startDate).toJSDate();
    }
    return this.args.startDate;
  }
  get endDate() {
    if (typeof this.args.endDate === 'string') {
      deprecate(`String passed to OfferingCalendar @endDate instead of Date`, false, {
        id: 'common.dates-no-strings',
        for: 'ilios-common',
        until: '72',
        since: '71'
      });
      return DateTime.fromISO(this.args.endDate).toJSDate();
    }
    return this.args.endDate;
  }
  get calendarEvents() {
    if (!this.currentEvent) {
      return [];
    }
    let events = [];
    if (this.showLearnerGroupEvents) {
      events = [...events, ...this.learnerGroupEvents];
    }
    if (this.showSessionEvents) {
      events = [...events, ...this.sessionEvents];
    }
    const currentEventIdentifier = this.currentEvent.name + this.currentEvent.startDate + this.currentEvent.endDate;
    const filteredEvents = events.filter(event => {
      if (!event) {
        return false;
      }
      const eventIdentifier = event.name + event.startDate + event.endDate;
      return eventIdentifier !== currentEventIdentifier;
    });
    return [...filteredEvents, this.currentEvent];
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "showLearnerGroupEvents", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showSessionEvents", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "learnerGroupEvents", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "sessionEvents", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "currentEvent", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _class);
export { OfferingCalendar as default };